import { styled } from '@mui/material/styles';
import { TextFieldStyles } from 'v3/shared/components/Inputs/styles/InputFormStyles';
import { RookeryBoldFont, RookeryRegularFont } from 'v3/styles/common';

export const SearchInputStyles = styled(TextFieldStyles)(({ theme }) => ({
  input: {
    font: `400 1rem ${RookeryRegularFont}`,
  },
  svg: {
    color: theme.palette.common.white,
    font: `700 1.375rem/1.25rem ${RookeryBoldFont}`,
  },
}));
